import React, {useEffect, useState} from "react";
import {Col, Row} from "reactstrap";
import classnames from "classnames";
import {Fade} from "@mui/material";
import {Check} from "@mui/icons-material";

const TopBarProgressIndicator = ({currentType, types, className, passed, auto = false}) => {
    const entries = Object.entries(types);

    return (
        <>
            <Row className={classnames('no-gutters', 'topbar-progress-indicator', className)}>
                <div className={`topbar-progress-indicator-height`}/>
                <Row className={`topbar-progress-indicator-row no-gutters`}>
                    {
                        entries?.map(([key, value]) => {
                            return (
                                <TopSectionBall
                                    key={key}
                                    currentType={currentType}
                                    type={value}
                                    passed={passed}
                                    auto={auto}
                                    length={entries?.length ?? 1}
                                />
                            );
                        })
                    }
                </Row>
            </Row>
        </>
    )
}

const TopSectionBall = ({currentType, type, length, passed, auto}) => {
    const [hasPassed, setHasPassed] = useState(false);
    const [selected, setSelected] = useState(false);

    /**
     * Listens for the changes in the current type and after each change, waits for 50 ms and then decides whether
     * this ball is selected and or passed.
     */
    useEffect(() => {
        const timer = setTimeout(() => {
            setHasPassed(passed(currentType, type));
            setSelected(type === currentType);
        }, 50)
        return () => clearTimeout(timer);
    }, [currentType])

    return (
        <Col {...(auto ? {} : {xs: Math.trunc(12 / length)})}
             className='d-flex flex-column align-items-center justify-content-start'>
            <p className={classnames(`topbar-progress-text`, {
                'selected': selected,
                'passed': hasPassed,
            })}>
                {type}
            </p>
            <div className={classnames('topbar-progress-indicator-ball', {
                'selected': selected,
                'passed': hasPassed,
            })}>
                <Fade in={hasPassed}>
                    <Check className={`icon small transition`}/>
                </Fade>
            </div>
        </Col>
    );
}

export default TopBarProgressIndicator;
